export default __webpack_public_path__ + "static/media/Review 2.0cab941a.png";